import { useWidget } from 'context/widget.context'
import { jsonColorConvertor } from 'utils/colorConvertor'
import style from './style.scss'

export default function Loading({ disable, isCircle }) {
  const { formData: { buttonBackground } } = useWidget()
  if (disable) return null
  const customizedStyle = {
    backgroundColor: jsonColorConvertor(buttonBackground),
  }
  const CircleSpinner =  <div className={style.lds_default}>{
    Array.from(new Array(12)).map((_, index) => <div key={index} style={customizedStyle} />)
  }</div>

  const FlatSpinner = <div className={style.lds_ellipsis}>{
    Array.from(new Array(4)).map((_, index) => <div key={index} style={customizedStyle} />)
  }</div>

  return <div className={style.loading}>
    {isCircle ? CircleSpinner : FlatSpinner}
  </div>
};
